import Vue from "vue";
import { Slide } from "vue-carousel";
import Vuex from "vuex";

import axios from "axios";
import cloneDeep from "lodash/cloneDeep";
import once from "lodash/once";
import maxBy from "lodash/maxBy";
import moment from "moment";
import slugify from "slugify";
import VisSenseFactory from "vissense";
import FeaturedReview from "../../components/FeaturedReview";
import ProductHeading from "../../components/ProductDetail/Heading";
import ReviewSection from "../../components/ProductDetail/Review";
import BookingWidget from "../../components/Resort/BookingWidget";
import DiveCenterAmenities from "../../components/Resort/DiveCenterAmenities";
import DiveCenterAmenitiesMobile from "../../components/Resort/DiveCenterAmenitiesMobile";
import SupplierActivitiesMobile from "../../components/core/SupplierActivitiesMobile";
import DotCarousel from "../../components/Resort/DotCarousel";
import GreenFinMembership from "../../components/Resort/GreenFinMembership";
import AwardBadge from "../../components/Resort/AwardBadge";
import BookingSummary from "../../components/Resort/HummingbirdFlow/BookingSummary";
import ContinueToReserve from "../../components/Resort/HummingbirdFlow/ContinueToReserve";
import TotalBookingMobile from "../../components/Resort/HummingbirdFlow/TotalBookingMobile";
import WhatsIncluded from "../../components/Resort/HummingbirdFlow/WhatsIncluded";
import PriceDetailsModal from "../../components/Resort/HummingbirdFlow/PriceDetailsModal";
import PriceNav from "../../components/Resort/HummingbirdFlow/PriceNav";
import OfferTagList from "../../components/Resort/OfferTagList";
import ResortAmenities from "../../components/Resort/ResortAmenities";
import ResortAmenitiesMobile from "../../components/Resort/ResortAmenitiesMobile";
import ResortChecklistMobile from "../../components/Resort/ResortChecklistMobile";
import ResortChecklist from "../../components/Resort/ResortChecklist";
import ResortFAQs from "../../components/Resort/ResortFAQs";
import ResortFooterMobile from "../../components/Resort/ResortFooterMobile";
import ResortHummingBird from "../../components/Resort/ResortHummingBird";
import ResortOffers from "../../components/Resort/ResortOffers";
import ResortRooms from "../../components/Resort/ResortRooms";
import EnquiryDirectBookingWidget from "../../components/core/Booking/EnquiryDirectBookingWidget";
import EnquiryDirectMobileBookingWidget from "../../components/core/Booking/EnquiryDirectMobileBookingWidget";
import Carousel from "../../components/core/Carousel";
import CurrencyContext from "../../components/core/CurrencyContext";
import Responsive from "../../components/core/Responsive";
import SupplierActivities from "../../components/core/SupplierActivities";
import ZbModal from "../../components/core/ZbModal";
import { syncURLParams } from "../../helpers/searchHelpers";
import BookingTermModal from "../../views/liveaboard/BookingTermModal";
import BookingTermPanel from "../../views/liveaboard/BookingTermPanel";
import initMobileGallery from "../common/initMobileGallery";
import { breakdownDealComponent } from "../../helpers/hummingbirdHelpers";
import {
  getMealPlanDescription,
  getMealPlanName,
  getMarginMarkup,
  applyMarkup,
  applyRoomMarkup,
  getHbtDeal,
} from "./helper";

Vue.use(Vuex);

$(document).ready(function () {
  initStickyNav();
  initMobileGallery();
  initStickySidebar();
});

const isMdsm = window.matchMedia("(max-width: 1200px)").matches;

function initStickySidebar() {
  const bookingWidget = $(".booking-widget-container");

  bookingWidget.stickySidebar({
    topSpacing: 96,
    containerSelector: ".sidebar-sticky-container",
    innerWrapperSelector: ".sidebar__inner",
    stickyClass: "is-sticky",
    resizeSensor: true,
  });
}

function initStickyNav() {
  const stickyHeader = $(".resort-nav");

  const h2s = Array.from(document.querySelectorAll("h2[data-sticky-nav-item]"));
  const list = stickyHeader.find("ul");
  list.empty();

  const hideItems = ["About", "Activities", "Conservation"];

  let index = 0;
  for (const h2 of h2s) {
    const slug = slugify(h2.textContent);
    h2.id = slug;

    let hiddenClass = "";

    if (h2.classList.contains("data-sticky-nav-item-hidden")) {
      hiddenClass = "hidden";
    }

    let title = h2.textContent.trim();

    if (title === "Choose your room") {
      title = "Rooms";
    }
    if (title === "Resort amenities") {
      title = "Amenities";
    }
    if (h2.textContent.trim() === "Frequently asked questions") {
      title = "FAQs";
    }

    if ((isMdsm && !hideItems.includes(title)) || !isMdsm) {
      list.append(`
      <li class="h-full mb-0">
        <a href="#${slug}" class="resort-nav-link outline-none font-medium ${hiddenClass} ${
        index === 0 ? "active" : ""
      }">
          ${title}
        </a>
      </li>
    `);
    }

    index++;
  }

  stickyHeader.stickySidebar({
    topSpacing: 0,
    bottomSpacing: 0,
    containerSelector: ".sticky-nav-container",
    innerWrapperSelector: ".sidebar__inner",
  });

  stickyHeader
    .get(0)
    .addEventListener("affixed.top.stickySidebar", function () {
      $(".resort-nav").addClass("resort-nav--show");
    });

  stickyHeader
    .get(0)
    .addEventListener("affix.static.stickySidebar", function () {
      $(".resort-nav").removeClass("resort-nav--show");
    });

  $(".resort-nav").navpoints();

  $(".choose-your-room").click(() => {
    window.scrollToElement($("h2#Rooms"));
  });
}

window.initStickyNav = initStickyNav;
window.addEventListener("init-bottom-nav", function () {
  const footerNav = $(".resort-footer-nav");
  const VisSense = VisSenseFactory(window);
  const resortInfo = VisSense(document.querySelector(".resort-info"));
  resortInfo
    .monitor({
      visible: function () {
        $(".resort-nav").removeClass("resort-nav--show");

        if (isMdsm) {
          footerNav.addClass("is-hidden");
          pushUpTrengoChat(false);
        }
      },
      hidden: function () {
        $(".resort-nav").addClass("resort-nav--show");

        if (isMdsm) {
          footerNav.removeClass("is-hidden");
          pushUpTrengoChat(true);
        }
      },
    })
    .start();
});

Vue.component("zb-modal", ZbModal);
Vue.component("carousel", Carousel);
Vue.component("v-slide", Slide);
Vue.component("zb-booking-widget", BookingWidget);
Vue.component("enquiry-direct-booking-widget", EnquiryDirectBookingWidget);
Vue.component(
  "enquiry-direct-mobile-booking-widget",
  EnquiryDirectMobileBookingWidget
);
Vue.component("responsive", Responsive);
Vue.component("resort-rooms", ResortRooms);
Vue.component("resort-amenities", ResortAmenities);
Vue.component("resort-amenities-mobile", ResortAmenitiesMobile);
Vue.component("resort-checklist-mobile", ResortChecklistMobile);
Vue.component("resort-checklist", ResortChecklist);
Vue.component("dive-center-amenities", DiveCenterAmenities);
Vue.component("dive-center-amenities-mobile", DiveCenterAmenitiesMobile);
Vue.component("booking-term-panel", BookingTermPanel);
Vue.component("booking-term-modal", BookingTermModal);
Vue.component("review-section", ReviewSection);
Vue.component("product-heading", ProductHeading);
Vue.component("supplier-activities", SupplierActivities);
Vue.component("resort-offers", ResortOffers);
Vue.component("offer-tag-list", OfferTagList);
Vue.component("dot-carousel", DotCarousel);
Vue.component("featured-review", FeaturedReview);
Vue.component("green-fin-membership", GreenFinMembership);
Vue.component("award-badge", AwardBadge);
Vue.component("currency-context", CurrencyContext);
Vue.component("resort-humming-bird", ResortHummingBird);
Vue.component("booking-summary", BookingSummary);
Vue.component("continue-to-reserve", ContinueToReserve);
Vue.component("total-booking-mobile", TotalBookingMobile);
Vue.component("resort-footer-mobile", ResortFooterMobile);
Vue.component("resort-faqs", ResortFAQs);
Vue.component("supplier-activities-mobile", SupplierActivitiesMobile);
Vue.component("whats-included", WhatsIncluded);
Vue.component("price-details-modal", PriceDetailsModal);
Vue.component("price-nav", PriceNav);

window.fetchSupplierInfo = once((supplierId) => {
  return new Promise((resolve, reject) => {
    $.get(
      `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/supplier_info?supplier_id=${supplierId}`
    )
      .done((res) => {
        if (res === "No Supplier Found") {
          reject();
        } else {
          resolve(res);
        }
      })
      .fail(reject);
  });
});

const apps = document.querySelectorAll(".vue-app");

const store = new Vuex.Store({
  state() {
    const searchParams = new URLSearchParams(window.location.search);
    let dates = [];
    let roomsFilter = [];
    let selectedRooms = [];

    if (searchParams.has("filter")) {
      const filter = searchParams.get("filter").split(",");
      const from = filter[0].split(":")[1];
      const to = filter[1].split(":")[1];
      dates = [moment(from), moment(to)];
    }

    for (let i = 1; i < 5; i++) {
      if (searchParams.has(`room${i}`)) {
        const room = searchParams.get(`room${i}`).split(",");
        const adults = Number(room[0].split(":")[1]);
        const children = Number(room[1].split(":")[1]);
        const childrenArr = [];
        if (children > 0) {
          const ageChild = room[2].split(":")[1];
          for (let j = 1; j <= children; j++) {
            childrenArr.push({
              id: j,
              age: Number(ageChild.split("_")[j - 1]),
            });
          }
        }
        roomsFilter.push({ id: i, adults, children: childrenArr });
      }
    }

    if (searchParams.has("deals") && searchParams.get("deals")) {
      const deals = searchParams.get("deals").split(",");
      selectedRooms = deals.map((_d, index) => {
        const group = _d.split("-")[0].replace("_", "-");
        const id = _d.split("-")[1];
        const roomCode = id.split(":")[1];
        const adults = roomsFilter[index].adults;
        const children = roomsFilter[index].children.length;
        return { group, id, roomCode, guests: { adults, children } };
      });
    }

    const selectedDealIdPerGroup = {};
    for (let i = 1; i < 10; ++i) {
      selectedDealIdPerGroup[`group-${i}`] = null;
    }

    return {
      offers: [],
      isLoadingRooms: false,
      groupsResult: [],
      dates,
      roomsFilter,
      bookingDates: [],
      bookingRooms: [],
      selectedRooms,
      supplierInfo: null,
      selectedGroupId: "group-1",
      selectedDealIdPerGroup,
      unavailability: false,
      requestHash: null,
      showPriceDetailsModal: false,
    };
  },
  getters: {
    getAllState(state) {
      return { ...state };
    },
    getMealPlanDescription(state) {
      return (code) => {
        return getMealPlanDescription(state.supplierInfo, code);
      };
    },
    getMealPlanName(state) {
      return (code) => {
        return getMealPlanName(state.supplierInfo, code);
      };
    },
    getDiscountForSelectedRoom(state, getters) {
      return (roomCode) => {
        const theGroup = state.groupsResult.find((group) => {
          return group.id === state.selectedGroupId;
        });

        if (!theGroup || !theGroup.rooms) return 0;

        const selectedDealId =
          state.selectedDealIdPerGroup[state.selectedGroupId];

        if (selectedDealId) {
          const dealComponents = breakdownDealComponent(selectedDealId);
          if (dealComponents.roomCode === roomCode) {
            const theDeal = getters.getHbtDeal(selectedDealId);

            if (theDeal) {
              const percentage =
                (theDeal.price.discount / theDeal.price.gross) * 100;
              return Math.ceil(percentage);
            }
          }
        }

        const theRoom = theGroup.rooms.find((room) => {
          return room.code === roomCode;
        });

        if (!theRoom || !theRoom.deals) return 0;

        const maxDiscountDeal = maxBy(theRoom.deals, (deal) => {
          const percentage = deal.price.discount / deal.price.gross;
          return percentage;
        });

        return Math.ceil(
          (maxDiscountDeal.price.discount / maxDiscountDeal.price.gross) * 100
        );
      };
    },
    hbtHotelCode(state) {
      if (!state.supplierInfo) return null;

      return state.supplierInfo.supplier.hbt_hotel_code;
    },
    hbtFlowEnabled(state) {
      if (!state.supplierInfo) return 0;
      return state.supplierInfo.supplier.hbt_flow_enabled;
    },
    hbtFlowChatOnly(state) {
      if (!state.supplierInfo) return 0;
      return state.supplierInfo.supplier.hbt_flow_chat_only;
    },
    marginMarkup(state) {
      return getMarginMarkup(state.supplierInfo);
    },
    paymentMarkup(state) {
      return 1.03;
    },
    applyMarkup(state, getters) {
      const paymentMarkup = getters.paymentMarkup;
      const marginMarkup = getters.marginMarkup;

      return (price) => {
        return applyMarkup(price, paymentMarkup, marginMarkup);
      };
    },
    applyRoomMarkup(state, getters) {
      return (roomCode, price) => {
        return applyRoomMarkup({
          price,
          theRoom: getters.getHbtRoom(roomCode),
          paymentMarkup: getters.paymentMarkup,
          applyMarkup: getters.applyMarkup,
        });
      };
    },
    getHbtRoom(state) {
      return (roomCode) => {
        const rooms = state.supplierInfo.supplier.hbt_rooms;
        const theRoom = rooms.find((room) => room.code === roomCode);

        return theRoom;
      };
    },
    getHbtRoomImages(state, getters) {
      return (roomCode) => {
        const theRoom = getters.getHbtRoom(roomCode);

        if (!theRoom) return [];
        if (!Array.isArray(theRoom.gallery)) return [];

        if (theRoom.gallery.length === 0) {
          return [theRoom.featuredImage];
        }

        return theRoom.gallery;
      };
    },
    getHbtDeal(state, getters) {
      return (dealId) => {
        return getHbtDeal({
          dealId,
          groupsResult: state.groupsResult,
          selectedGroupId: state.selectedGroupId,
        });
      };
    },
    travellersDisplay(state) {
      return ({ withRoom, withDay, withNight }) => {
        let result = null;
        let adultsTotal = 0;
        let childTotal = 0;

        state.roomsFilter.forEach((_r) => {
          adultsTotal += _r.adults;
          childTotal += _r.children.length;
        });
        if (adultsTotal > 1) result = `${adultsTotal} adults`;
        else if (adultsTotal === 1) result = `${adultsTotal} adult`;

        if (childTotal > 0) result += ` • ${childTotal} children`;

        if (withRoom) {
          if (state.roomsFilter.length > 1) {
            result += " • " + state.roomsFilter.length + " rooms";
          } else if (state.roomsFilter.length === 1) {
            result += " • " + state.roomsFilter.length + " room";
          }
        }

        if (withDay) {
          if (state.dates[0] && state.dates[1]) {
            const days = moment(state.dates[1]).diff(
              moment(state.dates[0]),
              "days"
            );
            result += ` • ${days}D ${days - 1}N`;
          } else if (state.dates[0] && !state.dates[1]) {
            result += ` • 1D`;
          }
        }

        if (withNight) {
          if (state.dates[0] && state.dates[1]) {
            const days = moment(state.dates[1]).diff(
              moment(state.dates[0]),
              "days"
            );
            result += ` • ${days - 1} nights`;
          } else if (state.dates[0] && !state.dates[1]) {
            result += ` • 1 night`;
          }
        }

        return result;
      };
    },
    getSelectedRoomDetails(state, getters) {
      return state.selectedRooms
        .map((room) => {
          const data = getters.getDealById(room.id, room.group);

          if (!!data.deal) {
            return {
              id: room.id,
              code: room.roomCode,
              name: data.roomName,
              deal: data.deal,
              groupId: room.group,
              group: `Room ${room.group.split("-")[1]}`,
              guests: room.guests,
              mealPlanDescription: getters.getMealPlanDescription(
                data.deal.info.accommodation.mealPlan.code
              ),
              mealPlanName: getters.getMealPlanName(
                data.deal.info.accommodation.mealPlan.code
              ),
              price: getters.applyRoomMarkup(room.code, data.deal.price.nett),
            };
          }
        })
        .filter(Boolean);
    },
    getTotalBooking(state, getters) {
      return getters.getSelectedRoomDetails.reduce((total, roomDetail) => {
        return (
          total +
          getters.applyRoomMarkup(roomDetail.code, roomDetail.deal.price.nett)
        );
      }, 0);
    },
    getDealById(state) {
      return (dealId, groupId) => {
        let deal = null;
        let roomName = "";

        state.groupsResult.forEach((group) => {
          group.rooms.forEach((room) => {
            room.deals.forEach((_deal) => {
              if (_deal.id === dealId && _deal.key.split(":")[0] === groupId) {
                deal = _deal;
                roomName = room.name;
              }
            });
          });
        });

        return { deal, roomName };
      };
    },
  },
  mutations: {
    setShowPriceDetailsModal(state, value) {
      state.showPriceDetailsModal = value;
    },
    setBookingDates(state, dates) {
      state.bookingDates = dates;
    },
    setBookingRooms(state, rooms) {
      state.bookingRooms = rooms;
    },
    setUnavailability(state, val) {
      state.unavailability = val;
    },
    setSupplierInfo(state, supplierInfo) {
      state.supplierInfo = supplierInfo;
    },
    setSelectedGroupId(state, groupType) {
      state.selectedGroupId = groupType;
    },
    setSelectedRooms(state, data) {
      state.selectedRooms = data;
    },
    setOffers(state, offers) {
      state.offers = offers;
    },
    setResult(state, groupsResult) {
      state.groupsResult = groupsResult;
    },
    setIsLoadingRooms(state, val) {
      state.isLoadingRooms = val;
    },
    setAdults(state, data) {
      const rooms = [...state.roomsFilter];
      rooms.forEach((_t) => {
        if (_t.id === data.id) {
          _t.adults = data.adults;
        }
      });
      state.roomsFilter = rooms;
    },
    setChildren(state, data) {
      const rooms = [...state.roomsFilter];
      rooms.forEach((_t) => {
        if (_t.id === data.id) {
          let result = [];
          if (data.child > 0) {
            for (let i = 1; i <= data.child; i++) {
              result.push({ id: i, age: 8 });
            }
          }
          _t.children = result;
        }
      });
      state.roomsFilter = rooms;
    },
    setAgeChild(state, data) {
      const index = state.roomsFilter.findIndex((_r) => _r.id === data.roomId);
      if (index >= 0) {
        const children = state.roomsFilter[index].children;
        children.forEach((_c) => {
          if (_c.id === data.id) {
            _c.age = data.age;
          }
        });
        state.roomsFilter[index].children = children;
      }
    },
    addRoom(state, data) {
      state.roomsFilter = data;
    },
    removeRoom(state, id) {
      const rooms = state.roomsFilter.filter((_r) => _r.id !== id);
      rooms.forEach((_r, index) => {
        _r.id = index + 1;
      });
      state.roomsFilter = rooms;
    },
    setDates(state, value) {
      state.dates = value;
    },
    setSelectedDealIdPerGroup(state, { groupId, dealId }) {
      state.selectedDealIdPerGroup[groupId] = dealId;
    },
    setRequestHash(state, hash) {
      state.requestHash = hash;
    },
  },
  actions: {
    clearResult(context) {
      context.commit("setResult", []);
      context.commit("setSelectedRooms", []);
      context.commit("setDates", []);
      context.commit("setBookingDates", []);
      context.commit("setBookingRooms", []);
      context.commit("setSelectedGroupId", "group-1");
      context.commit("setUnavailability", false);
      context.commit("setSelectedDealIdPerGroup", {});
      context.commit("setRequestHash", null);

      const searchParams = new URLSearchParams();
      const roomData = [...context.state.roomsFilter].map((roomFilter) => {
        const children = roomFilter.children.map((_c) => {
          return _c.age;
        });

        if (children.length) {
          return `guests:${roomFilter.adults},children:${
            roomFilter.children.length
          },ageChild:${children.join("_")}`;
        }
        return `guests:${roomFilter.adults},children:${roomFilter.children.length}`;
      });

      for (let i = 1; i < 5; i++) {
        searchParams.delete(`room${i}`);
      }

      roomData.forEach((room, index) => {
        searchParams.set(`room${index + 1}`, room);
      });

      syncURLParams(searchParams);
    },
    loadRooms(context, type) {
      window.fetchSupplierInfo().then((supplierResponse) => {
        context.commit("setSupplierInfo", supplierResponse);
        const hbtHotelCode = supplierResponse.supplier.hbt_hotel_code;

        if (
          hbtHotelCode &&
          context.state.dates[0] &&
          !!supplierResponse.supplier.hbt_flow_enabled
        ) {
          context.commit("setIsLoadingRooms", true);
          context.commit("setSelectedGroupId", "group-1");
          const roomRequests = context.state.roomsFilter.map((_r) => ({
            adults: _r.adults,
            children: _r.children.length,
            childAges: _r.children.map((_c) => _c.age),
          }));
          const body = {
            client: {
              userAgent: navigator.userAgent,
              url: window.location.href,
              supplierName: supplierResponse.supplier.name,
            },
            searchCriteria: {
              requestCriteria: {
                hotelCodes: [hbtHotelCode],
                destination: {
                  destinationCode: "MV",
                  locationCode: "ANY",
                },
                stayPeriod: {
                  checkInDate: moment(context.state.dates[0]).format(
                    "YYYY-MM-DD"
                  ),
                  checkOutDate: context.state.dates[1]
                    ? moment(context.state.dates[1]).format("YYYY-MM-DD")
                    : moment(context.state.dates[0]).format("YYYY-MM-DD"),
                },
                nationalityCode: "GB",
                roomRequests,
                preferences: {
                  availability: "all",
                },
              },
            },
          };

          axios
            .post(
              `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/hbt/price/search`,
              body
            )
            .then((response) => {
              if (
                response.data.data.result.length &&
                response.data.data.result[0].groups[0].rooms.length
              ) {
                context.commit(
                  "setRequestHash",
                  response.data.data.requestHash
                );
                const results = response.data.data.result[0].groups;
                if (type === "update-search") {
                  context.commit("setSelectedRooms", []);
                }
                context.commit(
                  "setBookingDates",
                  cloneDeep(context.state.dates)
                );
                context.commit(
                  "setBookingRooms",
                  cloneDeep(context.state.roomsFilter)
                );
                context.commit("setResult", results);
              } else {
                context.commit("setUnavailability", true);
                context.commit("setResult", []);
                context.commit("setSelectedRooms", []);
                context.commit("setBookingDates", []);
                context.commit("setBookingRooms", []);
              }
            })
            .catch((error) => {
              console.error(error);
              if (context.state.roomsFilter.length > 0) {
                context.commit("setUnavailability", true);
              }
              context.commit("setResult", []);
              context.commit("setSelectedRooms", []);
              context.commit("setBookingDates", []);
              context.commit("setBookingRooms", []);
            })
            .finally(() => {
              context.dispatch("updateFilterParamsUrl");
              context.dispatch("updateSelectedRoomsParamsUrl");
              context.commit("setIsLoadingRooms", false);
            });
        }
      });
    },
    updateFilterParamsUrl(context) {
      const searchParams = new URLSearchParams(window.location.search);
      const from = context.state.dates[0]
        ? moment(context.state.dates[0]).format("YYYY-MM-DD")
        : null;
      const to = context.state.dates[1]
        ? moment(context.state.dates[1]).format("YYYY-MM-DD")
        : context.state.dates[0];
      const roomData = [...context.state.roomsFilter].map((roomFilter) => {
        const children = roomFilter.children.map((_c) => {
          return _c.age;
        });

        if (children.length) {
          return `guests:${roomFilter.adults},children:${
            roomFilter.children.length
          },ageChild:${children.join("_")}`;
        }
        return `guests:${roomFilter.adults},children:${roomFilter.children.length}`;
      });

      for (let i = 1; i < 5; i++) {
        searchParams.delete(`room${i}`);
      }

      roomData.forEach((room, index) => {
        searchParams.set(`room${index + 1}`, room);
      });

      if (from && to) searchParams.set("filter", `from:${from},to:${to}`);

      syncURLParams(searchParams);
    },
    updateSelectedRoomsParamsUrl(context) {
      const searchParams = new URLSearchParams(window.location.search);
      const selectedRooms = context.state.selectedRooms;

      const deals = selectedRooms.map((room, index) => {
        return `${room.group.replace("-", "_")}-${room.id}`;
      });

      if (deals.length > 0) {
        searchParams.set("deals", deals.join(","));
      } else {
        searchParams.delete("deals");
      }
      syncURLParams(searchParams);
    },
  },
});

Array.prototype.forEach.call(
  apps,
  (el) =>
    new Vue({
      el,
      template: el.innerHTML,
      store,
    })
);
